import { UxAvatarEnum, UxBackgroundEnum, UxThemesEnum } from "@imaginelearning/mps-ux-component-library";
import useTheme from "hooks/usetheme";

const Config = () => {
  const { theme } = useTheme();
  const is6to8: boolean = theme === UxThemesEnum.STUDENT_6_8;
  const is9to12: boolean = theme === UxThemesEnum.STUDENT_9_12;
  let avatar: UxAvatarEnum = UxAvatarEnum.JOE;
  let background: UxBackgroundEnum = UxBackgroundEnum.DARK_GALAXY;
  let defaultAvatarsList: any = [];
  let defaultBackgroundsList: any = [];
  if (is9to12) {
    avatar = UxAvatarEnum.CAT;
    background = UxBackgroundEnum.PURPLE_PATTERN;
    defaultAvatarsList = [
      "cat",
      "grizzly",
      "lion",
      "shark",
      "monkey",
      "horse",
      "panda",
      "elk",
      "fox",
      "raccoon",
      "giraffe",
      "ace",
      "calvin",
      "dash",
      "denver",
      "harley",
      "ollie",
      "duke",
      "hux",
      "remy",
      "sonny"
    ];
    defaultBackgroundsList = [
      "purple_pattern",
      "big_wave",
      "bright_swatches",
      "deep_space",
      "happy_puppy",
      "leaves",
      "nap_time",
      "space_light",
      "sunny_stream",
      "waterfall",
      "mountains",
      "sea_coral",
      "desert_sunset",
      "tropics",
      "machu_picchu",
      "pyramids",
      "spider_web",
      "ancient_ruins",
      "horseshoe_bend",
      "whale_sunset",
      "amusement"
    ];
  } else if (is6to8) {
    avatar = UxAvatarEnum.OTTO;
    background = UxBackgroundEnum.PURPLE_PINWHEEL;
  }
  return {
    defaults: {
      avatar,
      background,
      maxLevelRequiredPoints: 500,
      defaultAvatarsList,
      defaultBackgroundsList
    }
  };
};

export default Config;
